// extracted by mini-css-extract-plugin
module.exports = {"ColClues":"Clues_ColClues__2Romi","RowClues":"Clues_RowClues__1Qm5X","Clue":"Clues_Clue__3GqRj","incorrect":"Clues_incorrect__3lo5x","complete":"Clues_complete__3TYTS"};